import type { FlexContainerIconWrapperProps } from "./flex-container-icon-wrapper.type";

import { Flex } from "antd";

const FlexContainerIconWrapper = ({
  icon,
  children,
}: FlexContainerIconWrapperProps) => {
  if (!icon) return children ?? null;
  return (
    <Flex gap="small" align="center">
      {icon}
      {children}
    </Flex>
  );
};

export default FlexContainerIconWrapper;
